const racquetModels = {
    Yonex: [
        'Astrox 99 Pro', 'Astrox 99 Game', 'Astrox 99',
        'Astrox 88D Pro', 'Astrox 88D Game', 'Astrox 88S Pro', 'Astrox 88S Game',
        'Astrox 77 Pro', 'Astrox 77 Game', 'Astrox 55', 'Astrox 38D', 'Astrox 38S',
        'Arcsaber 11 Pro', 'Arcsaber 11 Game', 'Arcsaber 7 Pro', 'Arcsaber FD',
        'Nanoflare 1000Z', 'Nanoflare 1000 Game', 'Nanoflare 800 Pro', 'Nanoflare 800 Game',
        'Nanoflare 700 Pro', 'Nanoflare 700 Game', 'Nanoflare 600', 'Nanoflare 500',
        'Nanoflare 380 Sharp', 'Nanoflare 270 Speed',
        'Duora 10', 'Duora Z-Strike', 'Duora 77',
    ],
    Victor: [
        'Thruster F', 'Thruster F C', 'Thruster Ryuga II Pro', 'Thruster Ryuga 3',
        'Blade X', 'Blade X Pro',
        'Brave Sword 12', 'Brave Sword LTD', 'Brave Sword 12B',
        'Auraspeed 100X', 'Auraspeed 90K', 'Auraspeed 80X', 'Auraspeed 9 Flare',
        'DriveX 10 Metiff', 'DriveX Nano 7', 'DriveX Smash F',
        'Jetspeed S12 II', 'Jetspeed S20',
        'HyperNano X 900', 'HyperNano X 800',
    ],
    'Li-Ning': [
        'Aeronaut 9000 Combat', 'Aeronaut 9000 I', 'Aeronaut 9000 C', 'Aeronaut 9000D',
        'Bladex 900', 'Bladex 800', 'Bladex 700',
        'Wind Lite 900', 'Wind Lite 800', 'Wind Lite 700',
        'Halbertec 9000', 'Halbertec 8000',
        'Ultra Carbon 9000', 'Ultra Carbon 7000',
        'Turbo Charging 75D', 'Turbo Charging 70C', 'Turbo Charging N9 II',
        'Tectonic 9', 'Tectonic 7',
    ],
    Felet: [
        'Woven Tech 5', 'Woven Tech 4', 'Woven Tech 3', 'Woven Tech X5',
        'SX Nano 6', 'SX Nano 5',
        'Black Dragon 2', 'Black Dragon',
        'Carbon Ultra 7', 'Carbon Ultra 5',
        'Hurricane 3', 'Hurricane 2',
    ],
    Toalson: [
        'Rapidshot X9', 'Rapidshot X7', 'Rapidshot X5',
        'Aerobite Series 01', 'Aerobite Pro',
        'Power Strike 75', 'Power Strike 65',
    ],
};

export default racquetModels;
